module.exports = __webpack_public_path__ + "img/文字背景2.309cb24f.png";